module.exports = __webpack_public_path__ + "img/03.29e285b9.jpg";